import * as _ from 'lodash'

/**
 * BlobをArrayBufferに変換
 * @param blob
 */
export function blobToArrayBuffer (blob: Blob): Promise<ArrayBuffer> {
  if (typeof blob.arrayBuffer === 'function') {
    // ネイティブで実装されている場合は使用する
    return blob.arrayBuffer()
  } else {
    // Safari用
    // FileReaderを使って実装する
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()

      fileReader.addEventListener('load', (e) => {
        const reader = e.target as FileReader
        if (reader) {
          const result = reader.result

          if (result && _.isArrayBuffer(result)) {
            resolve(result as ArrayBuffer)
          } else {
            reject(new Error('result is not ArrayBuffer.'))
          }
        } else {
          reject(new Error('fileReader target is undefined.'))
        }
      })
      fileReader.readAsArrayBuffer(blob)
    })
  }
}
